import { FormHelperText } from '@material-ui/core';
import React from 'react';

interface IProps {
  link: string;
}

function FaqLink({ link }: IProps) {
  return (
    <FormHelperText>
      Se tiver dúvidas acesse nosso{' '}
      <a style={{ fontWeight: 'bold' }} href={link} target='_blank' rel='noopener noreferrer'>
        FAQ
      </a>
    </FormHelperText>
  );
}

export default FaqLink;
